import type { MarketVariants } from '@/lib/i18n'

export type Slide08Copy = {
  title: string
}

export const copy: MarketVariants<Slide08Copy> = {
  US: {
    title: 'What are scammers after?',
  },
  ar: {
    title: 'ما الذي يسعى إليه المحتالون؟',
  },
}
